module.exports = new __parcel__URL__("atlaslogo.5491d009.svg").toString();